/**
 * @package pages/realtors/index
 */

import $ from 'jquery';

import { initAccordion } from '../../common/accordion';
import { getSearchFormUrl } from '../../common/common.es6';
import Form from '../../common/form';
import Ga from '../../common/ga';
import MAEvent from '../../common/ma-event';
import {
    handleSearchField,
    initializePlacesTypeahead,
    initializeRealtorsTypeahead,
} from '../../common/search';
import { bindForm } from '../../common/tagging';
import { addURLParams } from '../../common/utils';

/**
 * Search field for place
 * @type {jQuery}
 */
const $realtorsSearchPlaceField = $('[data-realtors-search-place]');

/**
 * Search field for realtor name
 * @type {jQuery}
 */
const $realtorsSearchNameField = $('[data-realtors-search-name]');

const $searchForm = $('[data-realtors-search-form]');

let urlPromise = null;

export function domReady() {
    let selectedPlace;

    let selectedRealtor;

    function resetSearchFieldError(searchFieldError) {
        searchFieldError.parents('.error').removeClass('error');
    }

    function handleStartedTagging() {
        $searchForm.trigger(MAEvent.formStarted);
    }

    $realtorsSearchPlaceField.on(
        'keydown',
        handleSearchField($realtorsSearchPlaceField, { resetHandler: resetSearchFieldError }),
    );
    $realtorsSearchNameField.on(
        'keydown',
        handleSearchField($realtorsSearchNameField, { resetHandler: resetSearchFieldError }),
    );

    $realtorsSearchPlaceField.keyup(handleStartedTagging);
    $realtorsSearchNameField.keyup(handleStartedTagging);

    $realtorsSearchPlaceField.on(MAEvent.placeSelected, event => {
        if (event.place) {
            selectedPlace = event.place;
            urlPromise = getSearchFormUrl(event.place);

            urlPromise.then(url => {
                const actionUrl = $searchForm.data('realtors-search-url').replace(':slug', url);
                $searchForm.attr('action', actionUrl);
                $searchForm.submit();
                return actionUrl;
            });
        } else {
            selectedPlace = '';
        }
    });

    $realtorsSearchNameField.on('blur', event => {
        const $this = $(event.target);
        if (!$this.typeahead('val')) {
            selectedRealtor = null;
        }
    });

    $realtorsSearchNameField.on(MAEvent.realtorSelected, event => {
        selectedRealtor = event.realtor;
        $searchForm.trigger(MAEvent.formSubmitAttempt);
        $searchForm.trigger(MAEvent.formSubmitSuccess);
        Ga.send({
            hitType: 'event',
            eventCategory: 'Annuaire agences',
            eventAction: 'go:realtor_page',
            eventLabel: 'find_a_pro:suggest_search_box',
        });
        document.location.href = event.realtor.url;
    });

    function goToResult() {
        if (urlPromise) {
            urlPromise.then(url => {
                const name = $realtorsSearchNameField.val();
                const label = `go:find_a_pro:${selectedPlace.geotype_label}${
                    name ? ':with_name' : ''
                }`;
                Ga.send({
                    hitType: 'event',
                    eventCategory: 'Annuaire agences',
                    eventAction: label,
                    eventLabel: 'realtors:landing_page:search_bar',
                });

                let submitUrl = url;
                if (name) {
                    submitUrl = addURLParams(url, { name });
                }

                document.location.href = submitUrl;
            });
        }
    }

    $searchForm.on('submit', event => {
        event.preventDefault();
        event.stopPropagation();
        $searchForm.trigger(MAEvent.formSubmitAttempt);

        if (!selectedPlace && !selectedRealtor) {
            $realtorsSearchPlaceField
                .parent()
                .parent()
                .addClass('error');
            $searchForm.trigger(MAEvent.formSubmitError);
        } else {
            $searchForm.trigger(MAEvent.formSubmitSuccess);
        }
    });

    /**
     * Init form
     */
    initializePlacesTypeahead($realtorsSearchPlaceField);
    initializeRealtorsTypeahead();

    Form.bindAjaxForm($searchForm, null, false);
    bindForm(
        $searchForm,
        {
            category: 'Annuaire agences',
            actionPrefix: 'find_a_pro:search_form',
            label: 'realtors:landing_page:search_bar',
        },
        undefined,
        undefined,
        goToResult,
    );

    initAccordion('[data-faq-accordion-button]');
}
